// extracted by mini-css-extract-plugin
module.exports = {"container":"Author_container__cET0l","details":"Author_details__SCdCg","title":"Author_title__AgMMu","description":"Author_description__8If7K","picture":"Author_picture__meTMt"};